export default __webpack_public_path__ + "86834eb561fd44d355a685c72d223b56.png";